import Theme from '@theme/Theme'

import { isBefore, isAfter, addDays, subDays } from 'date-fns'

const INITIAL_SCORE = 100
const MAJOR_POINTS = 25
const MINOR_POINTS = 10

const COLORS = {
  NON_CONFORME_MAJEUR: Theme.colors.priority,
  CONFORME: Theme.colors.closedLight,
  NON_CONFORME_MINEUR: Theme.colors.waitingLight,
  NON_CONCERNE: Theme.colors.secondaryText,
} as const

const TEXT_COLORS = {
  NON_CONFORME_MAJEUR: Theme.colors.secondary,
  CONFORME: Theme.colors.closed,
  NON_CONFORME_MINEUR: Theme.colors.waiting,
  NON_CONCERNE: Theme.colors.secondaryText,
} as const

const getControleScore = (responses: ControleResponseForm[]) => {
  const score = responses.reduce(
    (acc, cur) =>
      acc -
      (cur.conformite === 'NON_CONFORME_MAJEUR'
        ? MAJOR_POINTS
        : cur.conformite === 'NON_CONFORME_MINEUR'
        ? MINOR_POINTS
        : 0),
    INITIAL_SCORE
  )

  return Math.max(score, 0)
}

const scoreToRate = (score: number) =>
  score < 75
    ? ({ key: 'NON_CONFORME_MAJEUR', color: COLORS.NON_CONFORME_MAJEUR } as const)
    : score > 90
    ? ({ key: 'CONFORME', color: COLORS.CONFORME } as const)
    : ({ key: 'NON_CONFORME_MINEUR', color: COLORS.NON_CONFORME_MINEUR } as const)

const filterInTree = (item: LocationTreeItem, selected: string[]): boolean => {
  return selected.includes(item.location.id) || item.subs.some((sub) => filterInTree(sub, selected))
}

const findAllAuditable = (item: LocationTreeItem, selected: string[]): string[] => {
  const auditable = selected.includes(item.location.id)

  if (auditable) {
    return [item.location.id]
  }

  return item.subs.flatMap((sub) => findAllAuditable(sub, selected))
}

const isManifestationValidForCQ = (m: ManifestationResponse, date: Date | number) =>
  m.actif &&
  isAfter(date, subDays(new Date(m.dateDebutMontage), 5)) &&
  isBefore(date, addDays(new Date(m.dateFinDemontage), 15))

export { filterInTree, findAllAuditable, scoreToRate, getControleScore, isManifestationValidForCQ, COLORS, TEXT_COLORS }
